<template>
	<div class="container">
		<div
			class="main-tabs"
			aria-label="以下为年级选择区，包括小学，初中和高中三部分，您可以选中您想要浏览的年级，并进一步选择具体的科目。"
			tabindex="0">
			<!-- 主选项卡 -->
			<div
				:class="['tabs', { active: activeTab === 'ps' }]"
				@click="selectTab('ps')"
				@keydown.enter="selectTab('ps')"
				role="tab"
				:aria-label="(activeTab == 'ps' ? '已选中 ' : '') + '小学'"
				tabindex="0"
			>小学</div>
			<div
				:class="['tabs', { active: activeTab === 'jhs' }]"
				@click="selectTab('jhs')"
				@keydown.enter="selectTab('jhs')"
				role="tab"
				:aria-label="(activeTab == 'jhs' ? '已选中 ' : '') + '初中'"
				tabindex="0"
			>初中</div>
			<div
				:class="['tabs', { active: activeTab === 'shs' }]"
				@click="selectTab('shs')"
				@keydown.enter="selectTab('shs')"
				role="tab"
				:aria-label="(activeTab == 'shs' ? '已选中 ' : '') + '高中'"
				tabindex="0"
			>高中</div>
		</div>

		<div
			class="sub-tabs"
			aria-label="以下是科目选择区，包括语文，腧穴和英语等科目，您可以选中想浏览的科目，选中后将为您展示相应的课程。"
			tabindex="0">
			<!-- 子选项卡 -->
			<div
				v-for="(subTab, index) in currentSubTabs"
				:key="index"
				:class="['subtabs', { active: activeSubTab === subTab.tag }]"
				@click="selectSubTab(subTab.tag)"
				@keydown.enter="selectSubTab(subTab.tag)"
				role="tab"
				:aria-label="(activeSubTab === subTab.tag ? '已选中' : '') + subTab.name"
				tabindex="0"
			>{{ subTab.name }}</div>
		</div>

		<div v-if="total>0" class="course-container">
			<div 
				v-for="(course, index) in courses"
				:key="index"
				class="courses"
				@click="getChapters(index)"
				@keydown.enter="getChapters(index)"
			>
				<img
					:src="baseUrl+course.coverUrl"
					role="img"
				>
				<div
					class="courseName"
					role="link"
					tabindex="0"
				>{{ course.courseName }}</div>
			</div>
		</div>
		<div
			class="no-data-container"
			v-else
			tabindex="0"
		>暂无课程数据</div>
	</div>
</template>

<script>
import { baseUrl, fetchCoursesUrl } from "../constants/urls";
import axios from 'axios';

export default {
	data() {
		return {
			baseUrl: baseUrl,
			activeTab: "", // 当前选中的主选项卡
			activeSubTab: "", // 当前选中的子选项卡
			subTabs: {
				ps: [
					{ name: "语文", tag: "chinese" },
					{ name: "数学", tag: "math" },
					{ name: "英语", tag: "english" },
				],
				jhs: [
					{ name: "语文", tag: "chinese" },
					{ name: "数学", tag: "math" },
					{ name: "英语", tag: "english" },
					{ name: "物理", tag: "physics" },
					{ name: "化学", tag: "chemistry" },
				],
				shs: [
					{ name: "语文", tag: "chinese" },
					{ name: "数学", tag: "math" },
					{ name: "英语", tag: "english" },
					{ name: "物理", tag: "physics" },
					{ name: "化学", tag: "chemistry" },
					{ name: "生物", tag: "biology" },
				],
			},
			total: 0,
			courses: []
		};
	},
	created() {
		this.activeTab = 'ps';
		this.activeSubTab = "chinese"; // 重置子选项卡选中状态
		this.fetchCourses();
	},
	computed: {
		// 根据 activeTab 动态计算当前需要显示的子选项卡
		currentSubTabs() {
				return this.activeTab ? this.subTabs[this.activeTab] : [];
		},
	},
	methods: {
		// 选择主选项卡
		selectTab(tabName) {
			this.activeTab = tabName;
			this.activeSubTab = "chinese"; // 重置子选项卡选中状态
			this.fetchCourses();
		},
		selectSubTab(tag) {
			this.activeSubTab = tag;
			this.fetchCourses();
		},
		async fetchCourses() {
			const params={
				first_div: this.activeTab,
				second_div: this.activeSubTab
			};
			axios.get(baseUrl+fetchCoursesUrl, { params }).then(response =>{
				this.total=response.data.total;
				this.courses=response.data.data;
			});
		},
		getChapters(idx) {
			this.$router.push({
				name: "ChapterInfo",
				query: {
					course: JSON.stringify(this.courses[idx])	
				}
			});
		}
	}
}
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100%;
	margin-left: 40px;
	margin-right: auto;
	margin-top: 20vh;
}

.main-tabs {
	display: flex;
	flex-direction: row;
	gap: 10px;
}

.sub-tabs {
	display: flex;
	flex-direction: row;
	gap: 10px;
	margin-top: 10px;
}

.tabs,
.subtabs {
	padding: 10px 20px;
	cursor: pointer;
	border: 1px solid #ccc;
	border-radius: 5px;
	background-color: #f9f9f9;
	transition: background-color 0.3s ease;
}

.tabs:hover,
.subtabs:hover {
	background-color: #e0e0e0;
}

.tabs:focus,
.subtabs:focus {
	outline: none;
}

.tabs.active,
.subtabs.active {
	background: linear-gradient(to bottom, rgb(100, 255, 100), rgb(204, 255, 204));
	color: #006400;
	font-weight: bold;
}

.sub-tabs {
	display: flex;
	flex-direction: row;
	gap: 10px;
	margin-top: 10px;
	align-items: center;
	width: 100%;
	overflow-x: auto;
	white-space: nowrap;
}

.course-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
}

.courses {
	width: 200px;
  margin:20px;
  cursor: pointer;
}

.courses img {
  width: 100%;
  height: auto;
  max-height: 150px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 10px;
}

.courseName {
	display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  text-align: left;
  width: 100%;
}

.no-data-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 300px;
	width: 100%;
}

/* 移动端适配 */
@media (max-width: 768px) {
	.container {
		margin: 10px;
		margin-top: 15vh;
	}

	/* 主选项卡区域 & 子选项卡均匀占满整行 */
	.main-tabs {
		display: flex;
		justify-content: space-between;
		width: 100%;
		margin-top:50px;
	}

	.sub-tabs {
		display: flex;
		justify-content: space-between;
		width: 100%;
		white-space: nowrap;
		padding-bottom: 5px;
	}

	.tabs, .subtabs {
		flex: 1; /* 均匀分布 */
		text-align: center;
		padding: 8px 10px;
		font-size: 14px;
	}

	/* 课程布局：一行两列 */
	.course-container {
		display: grid;
		grid-template-columns: repeat(2, 1fr); /* 两列均分 */
		gap: 10px;
		width: 100%;
	}

	.courses {
		width: 100%;
		max-width: 100%; /* 让课程项自适应 */
		height: 150px;
	}
}
</style>
